export default "__VITE_ASSET__DqfpPHln__"